<div class="config-dialog">
  <div mat-dialog-content>
    <mat-tab-group class="config-tab-group">
      <mat-tab [label]="'key_general' | translate">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          class="first-dialog-item"
        >
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px grid"
          >
            <mat-form-field fxFlex="0 0 50">
              <input
                matInput
                disabled
                [placeholder]="'key_attributeName' | translate"
                [(ngModel)]="data.attribute.systemName"
              />
            </mat-form-field>
            <div fxFlex="0 0 50" fxLayout="column">
              <div
                fxFlex="1 1 50"
                style="
                  font-size: 12px;
                  font-weight: 400;
                  height: 18px;
                  color: rgba(0, 0, 0, 0.54);
                "
              >
                {{ 'key_layoutUnits' | translate }}
              </div>
              <mat-slider
                *ngIf="data.viewMode === 'tab'"
                fxFlex="none"
                [max]="12"
                [min]="1"
                [step]="1"
                [thumbLabel]="true"
                [tickInterval]="1"
                [(ngModel)]="data.config.units"
                style="margin-top: 2px; padding-left: 0"
              >
              </mat-slider>
              <mat-slider
                *ngIf="data.viewMode === 'gridster'"
                fxFlex="none"
                [max]="12"
                [min]="1"
                [step]="1"
                [thumbLabel]="true"
                [tickInterval]="1"
                [(ngModel)]="data.config.gridsterUnits"
                style="margin-top: 2px; padding-left: 0"
              >
              </mat-slider>
            </div>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px grid"
          >
            <div
              fxFlex="0 0 50"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="20px"
            >
              <mat-form-field fxFlex="0 0 50">
                <input
                  matInput
                  disabled
                  [placeholder]="'key_type' | translate"
                  [(ngModel)]="data.config.name"
                />
              </mat-form-field>
              <mat-form-field fxFlex="0 0 45">
                <input
                  matInput
                  type="number"
                  min="0"
                  [placeholder]="'key_hintLimit' | translate"
                  [(ngModel)]="data.config.hintLimit"
                />
              </mat-form-field>
            </div>
            <mat-form-field fxFlex="0 0 50">
              <mat-select
                [placeholder]="'key_tooltipContent' | translate"
                [(ngModel)]="data.config.tooltipContent"
              >
                <mat-option value="systemname">{{
                  'key_systemName' | translate
                }}</mat-option>
                <mat-option value="description">{{
                  'key_description' | translate
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              fxFlex="1 1 50"
              [(ngModel)]="data.config.showTooltip"
            >
              {{ 'key_showToolTip' | translate }}</mat-slide-toggle
            >
            <mat-slide-toggle
              fxFlex="1 1 50"
              [(ngModel)]="data.config.hideIfNoAccess"
            >
              {{ 'key_hideIfNoAccess' | translate }}</mat-slide-toggle
            >
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 30px"
          >
            <mat-slide-toggle
              fxFlex="1 1 50"
              [(ngModel)]="data.config.readOnly"
            >
              {{ 'key_readOnly' | translate }}</mat-slide-toggle
            >
            <mat-slide-toggle
              fxFlex="1 1 50"
              [(ngModel)]="data.config.required"
              [disabled]="data.config.requiredFromSchema"
            >
              {{ 'key_required' | translate }}</mat-slide-toggle
            >
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              #bolShowDisplayName
              fxFlex="1 1 50"
              [(ngModel)]="data.config.showDisplayName"
            >
              {{ 'key_showDisplayName' | translate }}</mat-slide-toggle
            >
            <mat-form-field fxFlex="1 1 50">
              <input
                matInput
                [placeholder]="'key_customDisplayName' | translate"
                [(ngModel)]="data.config.customDisplayName"
                [disabled]="!bolShowDisplayName.checked"
              />
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-slide-toggle
              #bolShowDescription
              fxFlex="1 1 50"
              [(ngModel)]="data.config.showDescription"
            >
              {{ 'key_showDescription' | translate }}</mat-slide-toggle
            >
            <mat-form-field fxFlex="1 1 50">
              <input
                matInput
                [placeholder]="'key_customDescription' | translate"
                [(ngModel)]="data.config.customDescription"
                [disabled]="!bolShowDescription.checked"
              />
            </mat-form-field>
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="'key_advanced' | translate">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          class="first-dialog-item"
        >
          <div fxFlex="none" *ngIf="data.creationMode">
            <mat-form-field fxFlex="auto">
              <textarea
                matInput
                [matTextareaAutosize]
                [matAutosizeMinRows]="1"
                [matAutosizeMaxRows]="6"
                [placeholder]="'key_initExpression' | translate"
                [(ngModel)]="data.config.initExpression"
              ></textarea>
            </mat-form-field>
          </div>
          <div fxFlex="none">
            <mat-form-field fxFlex="auto">
              <textarea
                matInput
                [matTextareaAutosize]
                [matAutosizeMinRows]="1"
                [matAutosizeMaxRows]="6"
                [placeholder]="'key_valueExpression' | translate"
                [(ngModel)]="data.config.expression"
              ></textarea>
            </mat-form-field>
          </div>
          <div fxFlex="none">
            <mat-form-field fxFlex="auto">
              <textarea
                matInput
                [matTextareaAutosize]
                [matAutosizeMinRows]="1"
                [matAutosizeMaxRows]="6"
                [placeholder]="'key_editableItemsQuery' | translate"
                [(ngModel)]="data.config.tableConfig.queryEditableItems"
              ></textarea>
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-form-field fxFlex="1 1 33">
              <input
                matInput
                [placeholder]="'key_formatDate' | translate"
                [(ngModel)]="data.config.tableConfig.datetimeFormat"
              />
            </mat-form-field>
            <mat-form-field fxFlex="1 1 33">
              <input
                matInput
                [placeholder]="'key_navigationKey' | translate"
                [(ngModel)]="data.config.tableConfig.navigationKey"
              />
            </mat-form-field>
            <mat-form-field fxFlex="1 1 33">
              <input
                matInput
                [placeholder]="'key_defaultLinkAction' | translate"
                [(ngModel)]="data.config.tableConfig.defaultLinkAction"
              />
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-form-field fxFlex="100">
              <mat-chip-list #clLinkActions>
                <mat-chip
                  *ngFor="let action of data.config.tableConfig.linkActions"
                  [selectable]="true"
                  [removable]="true"
                  (removed)="onRemoveLinkAction(action)"
                  style="font-size: 12px"
                >
                  {{ action }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input
                  [placeholder]="'key_linkActions' | translate"
                  [matChipInputFor]="clLinkActions"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="onAddLinkAction($event)"
                />
              </mat-chip-list>
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              fxFlex="50"
              [(ngModel)]="data.config.tableConfig.linkNoneForm"
            >
              {{ 'key_noneFormLink' | translate }}</mat-slide-toggle
            >
            <mat-slide-toggle
              fxFlex="50"
              [(ngModel)]="data.config.tableConfig.linkDisabled"
            >
              {{ 'key_disableLink' | translate }}</mat-slide-toggle
            >
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              fxFlex="1 1 50"
              [(ngModel)]="data.config.addMemberConfirmation"
            >
              {{ 'key_addMemberConfirmation' | translate }}</mat-slide-toggle
            >
            <mat-slide-toggle
              fxFlex="1 1 50"
              [(ngModel)]="data.config.removeMemberConfirmation"
            >
              {{ 'key_removeMemberConfirmation' | translate }}</mat-slide-toggle
            >
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="'key_display' | translate">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          class="first-dialog-item"
        >
          <div fxFlex="none" style="margin-bottom: 15px">
            <mat-radio-group [(ngModel)]="data.config.accessUsedFor">
              <div fxLayout="row">
                <mat-radio-button fxFlex="1 1 33" value="visibility">{{
                  'key_useForVisibility' | translate
                }}</mat-radio-button>
                <mat-radio-button fxFlex="1 1 33" value="editability">{{
                  'key_useForEditability' | translate
                }}</mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
          <div fxFlex="none">
            <mat-form-field fxFlex="auto">
              <mat-chip-list #clDeniedSets>
                <mat-chip
                  *ngFor="let deniedSet of data.config.accessDenied"
                  [selectable]="true"
                  [removable]="true"
                  (removed)="onRemoveDeniedSet(deniedSet)"
                >
                  {{ deniedSet }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input
                  [placeholder]="'key_deniedSets' | translate"
                  [matChipInputFor]="clDeniedSets"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="onAddDeniedSet($event)"
                />
              </mat-chip-list>
            </mat-form-field>
          </div>
          <div fxFlex="none">
            <mat-form-field fxFlex="auto">
              <mat-chip-list #clAllowedSets>
                <mat-chip
                  *ngFor="let alowedSet of data.config.accessAllowed"
                  [selectable]="true"
                  [removable]="true"
                  (removed)="onRemoveAllowedSet(alowedSet)"
                >
                  {{ alowedSet }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input
                  [placeholder]="'key_allowedSets' | translate"
                  [matChipInputFor]="clAllowedSets"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="onAddAllowedSet($event)"
                />
              </mat-chip-list>
            </mat-form-field>
          </div>
          <div fxFlex="none">
            <mat-form-field fxFlex="auto">
              <input
                matInput
                [placeholder]="'key_accessExpression' | translate"
                [(ngModel)]="data.config.accessExpression"
              />
            </mat-form-field>
          </div>
          <div
            *ngIf="data.config.accessUsedFor === 'visibility'"
            fxFlex="none"
            style="margin-top: 15px"
          >
            <mat-slide-toggle
              fxFlex="1 1 50"
              [(ngModel)]="data.config.hideFromDOM"
            >
              {{ 'key_hideFromDOM' | translate }}</mat-slide-toggle
            >
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="'key_columns' | translate">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          class="first-dialog-item"
        >
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="40" style="font-weight: 400; margin-bottom: 20px">
              {{ 'key_columnsToShow' | translate }}
            </div>
            <mat-form-field fxFlex="60">
              <input
                matInput
                [placeholder]="'key_resourceType' | translate"
                [(ngModel)]="data.config.tableConfig.objectType"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="margin-bottom: 40px">
            <div fxFlex="40" fxLayout="column">
              <div
                fxFlex="auto"
                dragula="COLUMNS"
                [(dragulaModel)]="data.config.tableConfig.columns"
                style="overflow-y: auto"
              >
                <div
                  *ngFor="let column of data.config.tableConfig.columns"
                  fxLayout="row"
                  [ngClass]="{
                    'attribute-cloumn-selected':
                      selectedColumnAttribute &&
                      column.field === selectedColumnAttribute.field
                  }"
                  class="attribute-column"
                  style="padding-left: 10px; margin: 5px 0"
                >
                  <div
                    fxFlex="auto"
                    style="line-height: 34px; cursor: pointer"
                    (click)="onSelectColumnAttribute(column)"
                  >
                    {{ column.field }}
                  </div>
                  <button
                    fxFlex="none"
                    mat-icon-button
                    color="warn"
                    [disableRipple]="true"
                    [matTooltip]="'key_delete' | translate"
                    (click)="onDeleteColumn(column)"
                  >
                    <mat-icon style="font-size: 20px; margin-top: -8px"
                      >delete_outline</mat-icon
                    >
                  </button>
                  <div
                    fxFlex="none"
                    class="handle"
                    style="width: 36px; cursor: pointer; color: lightgray"
                  >
                    <mat-icon style="line-height: 34px">menu</mat-icon>
                  </div>
                </div>
              </div>
              <div fxFlex="none" fxLayout="row" fxLayoutAlign="start end">
                <mat-form-field
                  fxFlex="auto"
                  style="margin-bottom: -20px; margin-right: 0"
                >
                  <input
                    matInput
                    [placeholder]="'key_addAttributeColumn' | translate"
                    [(ngModel)]="columnToAdd"
                  />
                </mat-form-field>
                <button
                  mat-icon-button
                  color="primary"
                  [disabled]="!columnToAdd"
                  (click)="onAddColumn()"
                >
                  <mat-icon>playlist_add</mat-icon>
                </button>
              </div>
            </div>
            <div fxFlex="60" class="attribute-column-setting">
              <div
                *ngIf="selectedColumnAttribute"
                fxLayout="column"
                fxLayoutGap="10px"
                style="font-size: 12px; padding: 10px"
              >
                <mat-form-field>
                  <input
                    matInput
                    [placeholder]="'key_field' | translate"
                    [(ngModel)]="selectedColumnAttribute.field"
                  />
                </mat-form-field>
                <mat-form-field>
                  <input
                    matInput
                    [placeholder]="'key_title' | translate"
                    [(ngModel)]="selectedColumnAttribute.title"
                  />
                </mat-form-field>
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div fxFlex="33">
                    <mat-slide-toggle
                      [(ngModel)]="selectedColumnAttribute.sortable"
                      (change)="onEnableSorting(selectedColumnAttribute)"
                      >{{ 'key_sortable' | translate }}</mat-slide-toggle
                    >
                  </div>
                  <div fxFlex="33">
                    <mat-slide-toggle
                      [(ngModel)]="selectedColumnAttribute.locked"
                      >{{ 'key_locked' | translate }}</mat-slide-toggle
                    >
                  </div>
                  <mat-form-field fxFlex="33">
                    <input
                      matInput
                      type="number"
                      min="-1"
                      max="800"
                      [placeholder]="'key_width' | translate"
                      [(ngModel)]="selectedColumnAttribute.width"
                    />
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div fxFlex="33">
                    <mat-slide-toggle
                      [(ngModel)]="selectedColumnAttribute.filterable"
                      >{{ 'key_filterable' | translate }}</mat-slide-toggle
                    >
                  </div>
                  <div fxFlex="33">
                    <mat-slide-toggle
                      [disabled]="!selectedColumnAttribute.filterable"
                      [(ngModel)]="selectedColumnAttribute.isReference"
                      (change)="
                        onEnableReferenceFilter(selectedColumnAttribute)
                      "
                      >{{ 'key_isReference' | translate }}</mat-slide-toggle
                    >
                  </div>
                  <mat-form-field fxFlex="33">
                    <mat-select
                      [disabled]="!selectedColumnAttribute.filterable"
                      [placeholder]="'key_filterType' | translate"
                      [(ngModel)]="selectedColumnAttribute.filter"
                    >
                      <mat-option value="text">text</mat-option>
                      <mat-option value="numeric">numeric</mat-option>
                      <mat-option value="boolean">boolean</mat-option>
                      <mat-option value="date">date</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxLayout="row">
                  <app-editor-iterables
                    #itrColumnStatus
                    fxFelx="none"
                    [simpleMode]="true"
                    [config]="columnStatusConfig"
                    [(ngModel)]="selectedColumnAttribute.showStatus"
                    (valueChange)="
                      onColumnStatusDefChange($event, selectedColumnAttribute)
                    "
                    style="font-size: 16px; width: 100%; margin-top: -20px"
                  ></app-editor-iterables>
                </div>
                <div
                  *ngIf="showFallbackStatus"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                >
                  <div fxFlex="33">{{ 'key_fallbackStatus' | translate }}</div>
                  <mat-form-field fxFlex="33">
                    <input
                      matInput
                      [placeholder]="'key_text' | translate"
                      [(ngModel)]="selectedColumnAttribute.fallbackStatus.text"
                    />
                  </mat-form-field>
                  <mat-form-field fxFlex="33">
                    <input
                      matInput
                      [placeholder]="'key_color' | translate"
                      [(ngModel)]="selectedColumnAttribute.fallbackStatus.color"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="'key_table' | translate">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          class="first-dialog-item"
        >
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-form-field fxFlex="50">
              <mat-select
                [placeholder]="'key_scrollType' | translate"
                [(ngModel)]="data.config.tableConfig.scrollMode"
              >
                <mat-option value="basic">{{
                  'key_basic' | translate
                }}</mat-option>
                <mat-option value="virtual">{{
                  'key_virtual' | translate
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div
              fxFlex="50"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="20px"
            >
              <mat-form-field fxFlex="50">
                <input
                  matInput
                  type="number"
                  min="0"
                  max="100"
                  [placeholder]="'key_scrollHeight' | translate"
                  [(ngModel)]="data.config.tableConfig.scrollHeight"
                  [disabled]="data.config.tableConfig.scrollMode === 'basic'"
                />
              </mat-form-field>
              <div fxFlex="50">
                <mat-slide-toggle
                  [(ngModel)]="data.config.tableConfig.selectable"
                  >{{ 'key_selectable' | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-form-field fxFlex="50">
              <mat-select
                [placeholder]="'key_pagingType' | translate"
                [(ngModel)]="data.config.tableConfig.pageType"
                [disabled]="data.config.tableConfig.scrollMode === 'virtual'"
              >
                <mat-option value="numeric">{{
                  'key_numeric' | translate
                }}</mat-option>
                <mat-option value="input">{{
                  'key_input' | translate
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div fxFlex="50">
              <mat-slide-toggle
                [disabled]="data.config.tableConfig.scrollMode === 'virtual'"
                [(ngModel)]="data.config.tableConfig.pageInfo"
                >{{ 'key_showPageInfo' | translate }}</mat-slide-toggle
              >
            </div>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <div fxFlex="50">
              <mat-form-field fxFlex="1 1 auto">
                <input
                  matInput
                  type="number"
                  min="1"
                  max="100"
                  [placeholder]="'key_pageSize' | translate"
                  [(ngModel)]="data.config.tableConfig.pageSize"
                />
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-slide-toggle
                [disabled]="data.config.tableConfig.scrollMode === 'virtual'"
                [(ngModel)]="data.config.tableConfig.pageButton"
                >{{ 'key_showPageButton' | translate }}</mat-slide-toggle
              >
            </div>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-form-field fxFlex="50">
              <input
                matInput
                type="number"
                min="1"
                [placeholder]="'key_tableHeight' | translate"
                [(ngModel)]="data.config.tableConfig.tableHeight"
              />
            </mat-form-field>
            <mat-form-field fxFlex="50">
              <input
                matInput
                type="number"
                min="1"
                max="10"
                [placeholder]="'key_padding' | translate"
                [(ngModel)]="data.config.tableConfig.cellPadding"
              />
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-form-field fxFlex="50">
              <input
                matInput
                type="number"
                min="10"
                max="20"
                [placeholder]="'key_fontSize' | translate"
                [(ngModel)]="data.config.tableConfig.fontSize"
              />
            </mat-form-field>
            <mat-form-field fxFlex="50">
              <input
                matInput
                type="number"
                min="100"
                max="900"
                [placeholder]="'key_fontWeight' | translate"
                [(ngModel)]="data.config.tableConfig.fontWeight"
              />
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-form-field fxFlex="33">
              <input
                matInput
                [placeholder]="'key_lockIcon' | translate"
                [(ngModel)]="data.config.tableConfig.lockIcon"
              />
            </mat-form-field>
            <mat-form-field fxFlex="33">
              <input
                matInput
                [placeholder]="'key_lockTooltip' | translate"
                [(ngModel)]="data.config.tableConfig.lockText"
              />
            </mat-form-field>
            <mat-form-field fxFlex="33">
              <mat-select
                [placeholder]="'key_iconColor' | translate"
                [(ngModel)]="data.config.tableConfig.lockColor"
              >
                <mat-option value="primary">{{
                  'key_primary' | translate
                }}</mat-option>
                <mat-option value="accent">{{
                  'key_accent' | translate
                }}</mat-option>
                <mat-option value="warn">{{
                  'key_warn' | translate
                }}</mat-option>
                <mat-option value="disabled">{{
                  'key_disabled' | translate
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            style="font-weight: 400; margin-bottom: 10px; margin-top: 10px"
          >
            {{ 'key_addSortingOptions' | translate }}
          </div>
          <app-editor-iterables
            fxFelx="none"
            [simpleMode]="true"
            [config]="sortConfig"
            [ngModel]="attrDetailSorting"
            style="font-size: 16px"
          ></app-editor-iterables>
        </div>
      </mat-tab>
      <mat-tab [label]="'key_identity' | translate">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          class="first-dialog-item"
        >
          <div fxFlex="none">
            <mat-form-field fxFlex="auto">
              <textarea
                matInput
                [matTextareaAutosize]
                [matAutosizeMinRows]="1"
                [matAutosizeMaxRows]="6"
                [placeholder]="'key_queryNormalSearch' | translate"
                [(ngModel)]="data.config.idpConfig.queryNormalSearch"
              ></textarea>
            </mat-form-field>
          </div>
          <div fxFlex="none">
            <mat-form-field fxFlex="auto">
              <textarea
                matInput
                [matTextareaAutosize]
                [matAutosizeMinRows]="1"
                [matAutosizeMaxRows]="6"
                [placeholder]="'key_queryExactSearch' | translate"
                [(ngModel)]="data.config.idpConfig.queryExactSearch"
              ></textarea>
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-slide-toggle
              fxFlex="30"
              [(ngModel)]="data.config.idpConfig.allowEmptySearch"
            >
              {{ 'key_allowEmptySearch' | translate }}</mat-slide-toggle
            >
            <mat-form-field fxFlex="70">
              <textarea
                matInput
                [matTextareaAutosize]
                [matAutosizeMinRows]="1"
                [matAutosizeMaxRows]="6"
                [disabled]="!data.config.idpConfig.allowEmptySearch"
                [required]="data.config.idpConfig.allowEmptySearch"
                [placeholder]="'key_queryEmptySearch' | translate"
                [(ngModel)]="data.config.idpConfig.queryEmptySearch"
              ></textarea>
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <div fxFlex="1 1 50" fxLayout="column">
              <div
                fxFlex="none"
                style="
                  font-size: 12px;
                  font-weight: 400;
                  height: 18px;
                  padding-left: 8px;
                  color: rgba(0, 0, 0, 0.54);
                "
              >
                {{ 'key_lettersToTrigger' | translate }}
              </div>
              <mat-slider
                fxFlex="none"
                [max]="10"
                [min]="2"
                [step]="1"
                [thumbLabel]="true"
                [tickInterval]="10"
                [(ngModel)]="data.config.idpConfig.lettersToTrigger"
                style="margin-top: 2px"
              >
              </mat-slider>
            </div>
            <div fxFlex="1 1 50" fxLayout="column">
              <div
                fxFlex="none"
                style="
                  font-size: 12px;
                  font-weight: 400;
                  height: 18px;
                  padding-left: 8px;
                  color: rgba(0, 0, 0, 0.54);
                "
              >
                {{ 'key_suggestionNumber' | translate }}
              </div>
              <mat-slider
                fxFlex="none"
                [max]="100"
                [min]="2"
                [step]="1"
                [thumbLabel]="true"
                [tickInterval]="10"
                [(ngModel)]="data.config.idpConfig.suggestionNumber"
                style="margin-top: 2px"
              >
              </mat-slider>
            </div>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <div fxFlex="1 1 50" fxLayout="column">
              <div
                fxFlex="none"
                style="
                  font-size: 12px;
                  font-weight: 400;
                  height: 18px;
                  padding-left: 8px;
                  color: rgba(0, 0, 0, 0.54);
                "
              >
                {{ 'key_maxSearchAllCount' | translate }}
              </div>
              <mat-slider
                fxFlex="none"
                [max]="500"
                [min]="20"
                [step]="10"
                [thumbLabel]="true"
                [tickInterval]="10"
                [(ngModel)]="data.config.idpConfig.emptySearchMaxCount"
                style="margin-top: 2px"
              >
              </mat-slider>
            </div>
            <mat-slide-toggle
              fxFlex="1 1 50"
              [disabled]="!data.config.idpConfig.isMultivalue"
              [(ngModel)]="data.config.idpConfig.showBulkImport"
            >
              {{ 'key_showBulkImport' | translate }}</mat-slide-toggle
            >
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="'key_popup' | translate">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          class="first-dialog-item"
        >
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="40" style="font-weight: 400; margin-bottom: 20px">
              {{ 'key_attributesToShow' | translate }}
            </div>
            <mat-form-field fxFlex="60">
              <input
                matInput
                [placeholder]="'key_resourceType' | translate"
                [(ngModel)]="data.config.idpConfig.objectType"
              />
            </mat-form-field>
          </div>
          <div fxLayout="row" style="margin-bottom: 40px">
            <div fxFlex="40" fxLayout="column">
              <div
                fxFlex="auto"
                dragula="COLUMNS"
                [(dragulaModel)]="data.config.idpConfig.attributesToShow"
                style="overflow-y: auto"
              >
                <div
                  *ngFor="let column of data.config.idpConfig.attributesToShow"
                  fxLayout="row"
                  [ngClass]="{
                    'attribute-cloumn-selected':
                      selectedPopupColumnAttribute &&
                      column.field === selectedPopupColumnAttribute.field
                  }"
                  class="attribute-column"
                  style="padding-left: 10px; margin: 5px 0"
                >
                  <div
                    fxFlex="auto"
                    style="line-height: 34px; cursor: pointer"
                    (click)="onSelectPopupColumnAttribute(column)"
                  >
                    {{ column.field }}
                  </div>
                  <button
                    fxFlex="none"
                    mat-icon-button
                    color="warn"
                    [disableRipple]="true"
                    [matTooltip]="'key_delete' | translate"
                    (click)="onDeletePopupColumn(column)"
                  >
                    <mat-icon style="font-size: 20px; margin-top: -8px"
                      >delete_outline</mat-icon
                    >
                  </button>
                  <div
                    fxFlex="none"
                    class="handle"
                    style="width: 36px; cursor: pointer; color: lightgray"
                  >
                    <mat-icon style="line-height: 34px">menu</mat-icon>
                  </div>
                </div>
              </div>
              <div fxFlex="none" fxLayout="row" fxLayoutAlign="start end">
                <mat-form-field
                  fxFlex="auto"
                  style="margin-bottom: -20px; margin-right: 0"
                >
                  <input
                    matInput
                    [placeholder]="'key_addAttributeColumn' | translate"
                    [(ngModel)]="popupColumnToAdd"
                  />
                </mat-form-field>
                <button
                  mat-icon-button
                  color="primary"
                  [disabled]="!popupColumnToAdd"
                  (click)="onAddPopupColumn()"
                >
                  <mat-icon>playlist_add</mat-icon>
                </button>
              </div>
            </div>
            <div fxFlex="60" class="attribute-column-setting">
              <div
                *ngIf="selectedPopupColumnAttribute"
                fxLayout="column"
                fxLayoutGap="10px"
                style="font-size: 12px; padding: 10px"
              >
                <mat-form-field>
                  <input
                    matInput
                    [placeholder]="'key_field' | translate"
                    [(ngModel)]="selectedPopupColumnAttribute.field"
                  />
                </mat-form-field>
                <mat-form-field>
                  <input
                    matInput
                    [placeholder]="'key_title' | translate"
                    [(ngModel)]="selectedPopupColumnAttribute.title"
                  />
                </mat-form-field>
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div fxFlex="33">
                    <mat-slide-toggle
                      [(ngModel)]="selectedPopupColumnAttribute.sortable"
                      >{{ 'key_sortable' | translate }}</mat-slide-toggle
                    >
                  </div>
                  <div fxFlex="33">
                    <mat-slide-toggle
                      [(ngModel)]="selectedPopupColumnAttribute.locked"
                      >{{ 'key_locked' | translate }}</mat-slide-toggle
                    >
                  </div>
                  <mat-form-field fxFlex="33">
                    <input
                      matInput
                      type="number"
                      min="-1"
                      max="800"
                      [placeholder]="'key_width' | translate"
                      [(ngModel)]="selectedPopupColumnAttribute.width"
                    />
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center">
                  <div fxFlex="33">
                    <mat-slide-toggle
                      [(ngModel)]="selectedPopupColumnAttribute.filterable"
                      >{{ 'key_filterable' | translate }}</mat-slide-toggle
                    >
                  </div>
                  <mat-form-field fxFlex="76">
                    <mat-select
                      [disabled]="!selectedPopupColumnAttribute.filterable"
                      [placeholder]="'key_filterType' | translate"
                      [(ngModel)]="selectedPopupColumnAttribute.filter"
                    >
                      <mat-option value="text">text</mat-option>
                      <mat-option value="numeric">numeric</mat-option>
                      <mat-option value="boolean">boolean</mat-option>
                      <mat-option value="date">date</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-slide-toggle
              fxFlex="1 1 33"
              [(ngModel)]="data.config.idpConfig.showPhoto"
            >
              {{ 'key_showPhoto' | translate }}</mat-slide-toggle
            >
            <mat-form-field fxFlex="1 1 33">
              <input
                matInput
                [disabled]="!data.config.idpConfig.showPhoto"
                [placeholder]="'key_photoAttribute' | translate"
                [(ngModel)]="data.config.idpConfig.photoAttribute"
              />
            </mat-form-field>
            <mat-form-field fxFlex="1 1 33">
              <input
                matInput
                [disabled]="!data.config.idpConfig.showPhoto"
                [placeholder]="'key_photoPlaceHolder' | translate"
                [(ngModel)]="data.config.idpConfig.photoPlaceHolder"
              />
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-form-field fxFlex="1 1 33">
              <input
                matInput
                type="number"
                min="0"
                max="800"
                [placeholder]="'key_popupHeight' | translate"
                [(ngModel)]="data.config.idpConfig.popupHeight"
              />
            </mat-form-field>
            <mat-form-field fxFlex="1 1 33">
              <input
                matInput
                type="number"
                min="0"
                max="800"
                [placeholder]="'key_popupWidth' | translate"
                [(ngModel)]="data.config.idpConfig.popupWidth"
              />
            </mat-form-field>
            <div fxFlex="1 1 33"></div>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
          >
            <mat-form-field fxFlex="1 1 33">
              <mat-select
                [placeholder]="'key_scrollType' | translate"
                [(ngModel)]="data.config.idpConfig.browserScrollMode"
              >
                <mat-option value="basic">{{
                  'key_basic' | translate
                }}</mat-option>
                <mat-option value="virtual">{{
                  'key_virtual' | translate
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex="1 1 33">
              <input
                matInput
                type="number"
                min="0"
                max="100"
                [placeholder]="'key_scrollHeight' | translate"
                [(ngModel)]="data.config.idpConfig.browserScrollHeight"
                [disabled]="data.config.idpConfig.browserScrollMode === 'basic'"
              />
            </mat-form-field>
            <mat-form-field fxFlex="1 1 33">
              <input
                matInput
                type="number"
                min="1"
                max="500"
                [placeholder]="'key_pageSize' | translate"
                [(ngModel)]="data.config.idpConfig.emptySearchMaxCount"
              />
            </mat-form-field>
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="'key_action' | translate">
        <div style="max-height: 500px">
          <div
            fxLayout="column"
            fxLayoutAlign="start stretch"
            class="first-dialog-item"
          >
            <div style="font-weight: 400; margin-bottom: 20px">
              {{ 'key_identitiesActionsDesc' | translate }}
            </div>
            <div
              fxFlex="none"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="30px"
            >
              <mat-form-field fxFlex="50">
                <mat-select
                  [placeholder]="'key_linkType' | translate"
                  [(ngModel)]="data.config.linkType"
                >
                  <mat-option value="null">{{ '--' | translate }}</mat-option>
                  <mat-option value="directlink">{{
                    'key_directLink' | translate
                  }}</mat-option>
                  <mat-option value="backlink">{{
                    'key_backLink' | translate
                  }}</mat-option>
                  <mat-option value="intermediat">{{
                    'key_intermediateObject' | translate
                  }}</mat-option>
                  <mat-option value="assignment"
                    >{{ 'l10n_assignment' | translate }} (obsolete)</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <mat-form-field
                *ngIf="
                  data.config.linkType === 'directlink' ||
                    data.config.linkType === 'backlink' ||
                    data.config.linkType === 'assignment';
                  else noLinkedAttribute
                "
                fxFlex="50"
              >
                <input
                  matInput
                  [placeholder]="'key_linkedAttribute' | translate"
                  [(ngModel)]="data.config.linkedAttribute"
                />
              </mat-form-field>
              <ng-template #noLinkedAttribute>
                <mat-form-field
                  *ngIf="
                    data.config.linkType === 'intermediat';
                    else usePlaceholder
                  "
                  fxFlex="50"
                >
                  <input
                    matInput
                    [placeholder]="'key_wizardToStart' | translate"
                    [(ngModel)]="data.config.intermediateWizardToStart"
                  />
                </mat-form-field>
                <ng-template #usePlaceholder>
                  <div fxFlex="50"></div>
                </ng-template>
              </ng-template>
            </div>
          </div>
          <div *ngIf="data.config.linkType === 'intermediat'">
            <form
              #intermediateAction="ngForm"
              autocomplete="off"
              (keydown.enter)="$event.preventDefault()"
            >
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="30px"
                style="margin-bottom: 10px"
              >
                <mat-form-field fxFlex="50">
                  <input
                    #fieldName="ngModel"
                    matInput
                    required
                    name="intermediateObjectType"
                    [placeholder]="'key_intermediateObjectType' | translate"
                    [(ngModel)]="data.config.intermediateObjectType"
                  />
                  <mat-error *ngIf="fieldName.hasError('required')">{{
                    'key_valueRequired' | translate
                  }}</mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="50">
                  <input
                    matInput
                    name="intermediateObjectName"
                    [placeholder]="'key_intermediateObjectName' | translate"
                    [(ngModel)]="data.config.intermediateObjectName"
                  />
                </mat-form-field>
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="30px"
              >
                <mat-form-field fxFlex="50">
                  <input
                    #fieldName="ngModel"
                    matInput
                    required
                    name="attributeForSource"
                    [placeholder]="'key_attributeForSource' | translate"
                    [(ngModel)]="data.config.intermediateAttributeForSource"
                  />
                  <mat-error *ngIf="fieldName.hasError('required')">{{
                    'key_valueRequired' | translate
                  }}</mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="50">
                  <input
                    #fieldName="ngModel"
                    matInput
                    required
                    name="attributeForTarget"
                    [placeholder]="'key_attributeForTarget' | translate"
                    [(ngModel)]="data.config.intermediateAttributeForTarget"
                  />
                  <mat-error *ngIf="fieldName.hasError('required')">{{
                    'key_valueRequired' | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
              <div style="margin-top: 20px"></div>
              <app-editor-iterables
                name="itrParameters"
                [config]="intermediatConfig"
                [(ngModel)]="attrIntermediat"
                (valueChange)="onAdditionalAttributesChange()"
              ></app-editor-iterables>
            </form>
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="'key_export' | translate">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          class="first-dialog-item"
        >
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              fxFlex="0 0 33"
              [(ngModel)]="data.config.tableConfig.exportToClipBoard"
            >
              {{ 'key_exportToClipboard' | translate }}</mat-slide-toggle
            >
            <mat-slide-toggle
              fxFlex="0 0 66"
              [(ngModel)]="data.config.tableConfig.exportToExcel"
            >
              {{ 'key_exportToExcel' | translate }}</mat-slide-toggle
            >
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              fxFlex="0 0 33"
              [(ngModel)]="data.config.tableConfig.exportAllPages"
            >
              {{ 'key_exportAllPages' | translate }}</mat-slide-toggle
            >
            <mat-form-field fxFlex="0 0 33">
              <input
                matInput
                type="number"
                [min]="0"
                [placeholder]="'key_exportMaxCount' | translate"
                [(ngModel)]="data.config.tableConfig.exportMaxCount"
              />
            </mat-form-field>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              fxFlex="0 0 33"
              [(ngModel)]="data.config.tableConfig.exportReferenceId"
            >
              {{ 'key_exportReferenceId' | translate }}</mat-slide-toggle
            >
            <mat-slide-toggle
              fxFlex="0 0 33"
              [(ngModel)]="data.config.tableConfig.exportHeader"
              [disabled]="!data.config.tableConfig.exportToClipBoard"
            >
              {{ 'key_exportHeader' | translate }}</mat-slide-toggle
            >
            <div fxFlex="0 0 33">
              <mat-form-field style="margin-top: -20px">
                <input
                  matInput
                  [placeholder]="'key_separator' | translate"
                  [(ngModel)]="data.config.tableConfig.exportSeparator"
                  [disabled]="!data.config.tableConfig.exportToClipBoard"
                />
              </mat-form-field>
            </div>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              fxFlex="0 0 33"
              [(ngModel)]="data.config.tableConfig.exportState.enabled"
              [disabled]="!data.config.tableConfig.exportToClipBoard"
            >
              {{ 'key_exportState' | translate }}</mat-slide-toggle
            >
            <div fxFlex="0 0 33">
              <mat-form-field style="margin-top: -20px">
                <input
                  matInput
                  [placeholder]="'key_stateLocked' | translate"
                  [(ngModel)]="data.config.tableConfig.exportState.stateLocked"
                  [disabled]="
                    !data.config.tableConfig.exportToClipBoard ||
                    !data.config.tableConfig.exportState.enabled
                  "
                />
              </mat-form-field>
            </div>
            <div fxFlex="0 0 33">
              <mat-form-field style="margin-top: -20px">
                <input
                  matInput
                  [placeholder]="'key_stateUnlocked' | translate"
                  [(ngModel)]="
                    data.config.tableConfig.exportState.stateUnlocked
                  "
                  [disabled]="
                    !data.config.tableConfig.exportToClipBoard ||
                    !data.config.tableConfig.exportState.enabled
                  "
                />
              </mat-form-field>
            </div>
          </div>
          <div fxFlex="none" style="margin-top: 40px">
            {{ 'key_attributesToExport' | translate }}
          </div>
          <div fxFlex="none" fxLayout="column" fxLayoutGap="20px">
            <mat-list fxFlex="none">
              <div>
                <mat-list-item
                  *ngFor="
                    let attribute of data.config.tableConfig.exportAttributes
                  "
                  style="
                    border: solid lightgray;
                    height: 38px;
                    margin-top: -2px;
                    padding-top: 2px;
                    color: gray;
                  "
                >
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="20px"
                    style="width: 100%"
                  >
                    <div fxFlex="auto" style="padding-bottom: 6px">
                      {{ attribute }}
                    </div>
                    <div fxFlex="0 0 20px">
                      <mat-icon
                        (click)="onRemoveExportAttribute(attribute)"
                        style="cursor: pointer"
                        >clear</mat-icon
                      >
                    </div>
                  </div>
                </mat-list-item>
              </div>
            </mat-list>
            <div
              fxFlex="none"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="40px"
            >
              <mat-form-field fxFlex="auto">
                <mat-select
                  #cmbExportAttribute
                  [placeholder]="'key_attributeName' | translate"
                >
                  <mat-option
                    *ngFor="let col of data.config.tableConfig.columns"
                    [value]="col.field"
                    >{{ col.field }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <button
                fxFlex="120px"
                mat-stroked-button
                [disabled]="!cmbExportAttribute.value"
                (click)="onAddExportAttribute(cmbExportAttribute.value)"
                style="height: 36px"
              >
                {{ 'key_add' | translate }}
              </button>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="'key_copyPaste' | translate">
        <div
          fxLayout="column"
          fxLayoutAlign="start stretch"
          class="first-dialog-item"
        >
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              fxFlex="0 0 33"
              [(ngModel)]="data.config.enableDataExchange"
            >
              {{ 'key_enableDataExchange' | translate }}</mat-slide-toggle
            >
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px"
          >
            <mat-slide-toggle
              fxFlex="0 0 33"
              [(ngModel)]="data.config.dataExchangeCheckType"
              [disabled]="!data.config.enableDataExchange"
            >
              {{ 'key_checkType' | translate }}</mat-slide-toggle
            >
            <mat-form-field fxFlex="0 0 33">
              <input
                matInput
                type="number"
                [placeholder]="'key_dataExchangeLimit' | translate"
                [(ngModel)]="data.config.dataExchangeLimit"
                [disabled]="!data.config.enableDataExchange"
              />
            </mat-form-field>
            <div fxFlex="0 0 33">
              <mat-form-field>
                <input
                  matInput
                  [placeholder]="'key_dataExchangeAttribute' | translate"
                  [(ngModel)]="data.config.dataExchangeAttribute"
                  [disabled]="!data.config.enableDataExchange"
                />
              </mat-form-field>
            </div>
          </div>
          <div
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            style="margin-top: 20px; margin-bottom: 20px"
          >
            <mat-slide-toggle
              fxFlex="0 0 33"
              [(ngModel)]="data.config.enableRemoveAll"
            >
              {{ 'key_enableRemoveAll' | translate }}</mat-slide-toggle
            >
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div
    mat-dialog-actions
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="20px"
    style="margin-top: 10px"
  >
    <button
      fxFlex="none"
      mat-stroked-button
      color="primary"
      (click)="onClose()"
      [disabled]="
        !formIsValid ||
        (data.config.idpConfig.allowEmptySearch &&
          !data.config.idpConfig.queryEmptySearch)
      "
    >
      {{ 'key_submit' | translate }}
    </button>
    <button
      fxFlex="none"
      mat-stroked-button
      style="margin-left: 20px"
      (click)="onExportSetting()"
    >
      {{ 'key_exportSetting' | translate }}
    </button>
    <div fxFlex="auto"></div>
    <button fxFlex="none" mat-stroked-button (click)="onCancel()">
      {{ 'key_cancel' | translate }}
    </button>
  </div>
</div>
<ng-template #titleBar let-win>
  <app-popup-title
    [win]="win"
    [title]="'key_editorConfig'"
    [leftPadding]="leftPadding"
  ></app-popup-title>
</ng-template>
